// Company-page FAQ shared by the tech lists (also emitted as FAQPage JSON-LD).
// `singular` and `plural` are the role nouns as they read mid-sentence:
// "the Google security engineer interview process", "pay security engineers".
import {fmtRange} from './format';

const makeCompanyFaqItems = ({singular, plural}) => (job, updatedLabel) => {
  const items = [];

  if (job.baseSalary || job.totalComp) {
    items.push({
      question: `How much does ${job.company} pay ${plural}?`,
      answer: `${job.baseSalary ? `${job.company}’s posted base band is ${fmtRange(job.baseSalary)}.` : ''}${job.totalComp ? ` Estimated total compensation including equity is ${fmtRange(job.totalComp)}.` : ''} ${job.compNote}`.trim(),
    });
  } else {
    items.push({
      question: `How much does ${job.company} pay ${plural}?`,
      answer: `${job.company} doesn’t publish salary ranges for this role. ${job.compNote}`,
    });
  }

  items.push({
    question: `Is ${job.company} hiring ${plural} right now?`,
    answer: `As of ${updatedLabel}: ${job.hiringStatus}. Check the live careers page for current reqs.`,
  });

  items.push({
    question: `Does ${job.company} hire entry-level ${plural}?`,
    answer: job.newGradFriendly
      ? `Yes — there is an early-career path. ${job.experience}`
      : `Not typically. ${job.experience}`,
  });

  items.push({
    question: `Are ${job.company} ${singular} roles remote?`,
    answer: job.remoteFriendly
      ? `Some are. ${job.arrangement}.`
      : `Mostly not. ${job.arrangement}.`,
  });

  return items;
};

export default makeCompanyFaqItems;
